import { gql } from '@grandvisionhq/graphql';
import { cartDetails } from '../fragments/cart-details.js';
import { cartValidationErrors } from '../fragments/cart-validation-errors.js';

const ADD_CART_LINE_ITEMS = gql`
  mutation AddCartLineItems($cartInput: AddCartLineItemsInput!) {
    addCartLineItems(cartInput: $cartInput) {
      cart {
        ...CartDetailsFragment
      }
      validationErrors {
        ...CartValidationErrorsFragment
      }
      success
    }
  }
  ${cartDetails}
  ${cartValidationErrors}
`;

export { ADD_CART_LINE_ITEMS };
//# sourceMappingURL=add-cart-line-items.js.map
